module.exports = __webpack_public_path__ + "img/bg111.6b52f9a8.png";